import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function SideBar() {
  const token = sessionStorage.getItem('token');
  const [userData, setUserData] = useState({})

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserData(decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, [token]);

  console.log("Token Data", userData)

  return (
    <div id="left-sidebar" className="sidebar">
      <div className="user-account">
        <div className=" d-flex border-bottom justify-content-center flex-column align-items-center">
          <div
            className="profile-image m-3 border-2 "
            style={{ height: "55px", width: "55px" }}
          >
            <img
              src={"https://img.freepik.com/premium-photo/fluid-organic-white-color-abstract-background-unique-designs_851755-381525.jpg?semt=ais_hybrid&w=740"}
              className="rounded-circle tw-text-xs"
              alt=""
            />
          </div>
        </div>
      </div>

      <div className="tab-content ">
        <div
          className={"tab-pane fade show active border-bottom"}
          id="hr_menu"
          role="tabpanel"
        >
          <nav className="sidebar-nav">
            <ul className="metismenu list-unstyled" id="menu">
              <li className="dashboard">
                <NavLink
                  className="menu-item-single"
                  to="/dashboard"
                >
                  <i className="fa fa-tachometer"></i>
                  <span>Dashboard</span>
                </NavLink>
              </li>

              <li className="uploaded">
                <NavLink
                  className="menu-item-single"
                  to="/uploaded_file"
                >
                  <i className="fa fa-upload"></i>
                  <span>Uploaded Files</span>
                </NavLink>
              </li>

              <li className="message">
                <NavLink
                  className="menu-item-single"
                  to="/message_records"
                >
                  <i className="fa fa-list"></i>
                  <span>Message Records</span>
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div className="user-account">
        <div className=" border-bottom d-flex justify-content-center items-center flex-column">
          <img
            src={"https://isleephst.com/cdn/shop/files/logo_1.svg?v=1738802582&width=220"}
            className="avatar lg rounded"
            alt="iSleep Logo"
            style={{ height: "auto !important", width: "130px", objectFit: "scale-down", margin: "auto" }}
          />
          <img
            src={"https://fileshare.servusys.in/static/media/servusys.0119b62bc157b4a659a1.jpg"}
            className="avatar lg rounded mt-2"
            alt="Servusys Logo"
            style={{ height: "auto !important", width: "130px", objectFit: "scale-down", margin: "auto" }}
          />
        </div>
        <div className="my-2">
          <span className="d-flex justify-content-center align-content-center">
            Autorised User:
          </span>
          <p className="text-center"> Secured Credentials</p>
          <p style={{ fontWeight: "bold", textAlign: "center", marginTop: "50px" }}>
            User: &nbsp; {userData?.Name || "N/A"}</p>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
